import { Navigate, Route, Routes, useMatch, useParams } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';
import { ArrowBack, AssignmentLate } from '@mui/icons-material';
import { useShopGroupsContext } from '../../contexts/ShopGroupContext';
import ShopGroupPages from './pages/types';
import useShopGroups from '../../hooks/data/useShopGroups';
import Sidenav from '../../components/Sidebar/Sidenav';
import NavItem from '../../components/Sidebar/NavItem';
import { useFetch } from '../../hooks';
import BasicData from './pages/BasicInfo';

const ShopGroupRouter = (): JSX.Element => {
  const { pathnameBase } = useMatch({ path: '/shop-groups/:id/*' })!;

  return (
    <Routes>
      <Route path="/" element={<Navigate to={`${pathnameBase}/basic-info`} replace />} />
      <Route path="/basic-info" element={<BasicData />} />
    </Routes>
  );
};

export const ShopGroup = (): JSX.Element => {
  const { id } = useParams<{ id: string }>();
  const repository = useShopGroups();
  const { setShopGroup, setLoading, handleUnselectShopGroup } = useShopGroupsContext();

  const { data, loading, refetch } = useFetch((selectedId?: string) => repository.fetchById((selectedId ?? id)!), {
    ignoreFirstCall: true,
  });
  const [activePage, setActivePage] = useState<ShopGroupPages>();
  const match = useMatch({ path: '/shop-groups/:id/*' });

  const getActivePage = useCallback((page: ShopGroupPages) => page === activePage, [activePage]);

  useEffect(() => {
    if (match) {
      const { pathnameBase, pathname: _path } = match;
      const initialRoute = _path.replace(pathnameBase, '').replace('/', '');
      setActivePage(initialRoute as ShopGroupPages);
    }
  }, [match]);

  useEffect(() => {
    setLoading(loading);
  }, [loading, setLoading]);

  useEffect(() => {
    setShopGroup(data ?? null);
  }, [data, setShopGroup]);

  useEffect(() => {
    if (id !== 'new') {
      refetch(id);
    }
  }, [id, refetch]);

  return (
    <>
      <Sidenav>
        <>
          <NavItem title="voltar" icon={<ArrowBack />} onClick={() => handleUnselectShopGroup()} />
          <NavItem title="dados básicos" icon={<AssignmentLate />} active={getActivePage(ShopGroupPages.BasicInfo)} />
        </>
      </Sidenav>
      <ShopGroupRouter />
    </>
  );
};

export default ShopGroup;
